import { DSInput } from "@components/design-system/molecules";
import React from "react";
import { Controller, useFormState } from "react-hook-form";

import { FormatHint } from "./FormatHint";

export function AgeInput({ control }) {
  const { errors } = useFormState({ control });

  return (
    <div className="flex flex-col items-center space-x-2">
      <FormatHint>Format: # weeks/months/years</FormatHint>

      <div className="flex flex-row space-x-2">
        <AgeInputPart
          control={control}
          name={"weeks"}
          minValue={0}
          maxValue={52}
        />
        <AgeInputPart
          control={control}
          name={"months"}
          minValue={0}
          maxValue={12}
        />
        <AgeInputPart
          control={control}
          name={"years"}
          minValue={0}
          maxValue={100}
        />
      </div>

      {errors.weeks && (
        <span className="text-xs text-danger text-center">
          Weeks must be a number less than 52.
        </span>
      )}
      {errors.months && (
        <span className="text-xs text-danger text-center">
          Months must be a number less than 12.
        </span>
      )}
      {errors.years && (
        <span className="text-xs text-danger text-center">
          Years must be a number less than 100.
        </span>
      )}
    </div>
  );
}

function AgeInputPart({ control, minValue, maxValue, name }) {
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        validate: {
          positiveNumber: (value) => {
            parseFloat(value) >= minValue &&
              parseFloat(value) < maxValue;
          },
        },
      }}
      render={({ field }) => (
        <DSInput
          placeholder={capitalize(name)}
          dataTestId={name}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          {...field}
          onChange={(e) =>
            field.onChange(
              e.target.value === "" ? null : Number(e.target.value),
            )
          }
        />
      )}
    />
  );
}
